import { withEngagingURL } from '../../../decorators'
import { useGenericRequestHandler } from '../../../handlers'
import type { GenericHandlerValues } from '../../../models'

export type UseMoteCancelMutationValues = GenericHandlerValues<null, 'POST'>

export const useMoteCancelMutation = (): UseMoteCancelMutationValues => {
  const values = useGenericRequestHandler({
    route: 'v1/m/cancel',
    method: 'POST'
  })
  //@ts-expect-error
  return withEngagingURL(values)
}
